'use strict';

var processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('friartux/virtual/virtual'));
    processInclude(require('friartux/components/inputDate'));
    processInclude(require('friartux/appointmentModal/appointmentModal'));
});
